import { createTheme } from '@mui/material';
import theme from './theme.js';
import spacing from './spacing/index.js';

export const muiTheme = createTheme({
  boxShadows: theme.boxShadows,
  breakpoints: {
    values: theme.breakpoints.values,
  },
  colors: theme.colors,
  components: {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0,0,0,0.4)',
        },
      },
    },
  },
  spacing,
  zIndex: theme.zIndex,
});
